/* Read-only presentation. Never writes or replaces Shopify properties. */
(() => {
  if (customElements.get('gpp-cart-arrangement')) return;
  class GPPCartArrangement extends HTMLElement {
    connectedCallback() {
      const original = this.querySelector('[data-gpp-arrangement-original]');
      const summary = this.querySelector('[data-gpp-arrangement-summary]');
      if (!original || !summary) return;
      const raw = original.textContent;
      const unit = Number(this.dataset.units), quantity = Number(this.dataset.quantity);
      const escapedTitle = this.dataset.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const pattern = new RegExp(`^Platter ([1-9]\\d*): Quantity ([1-9]\\d*) of ${escapedTitle} \\(([1-9]\\d*) units; Quantity 1 = ([1-9]\\d*) units\\)$`);
      const segments = raw.split('; Platter ').map((s, i) => i ? 'Platter ' + s : s);
      const parsed = segments.map(s => s.match(pattern));
      const seen = new Set();
      const valid = parsed.every(m => {
        if (!m) return false;
        const [n, q, total, each] = m.slice(1).map(Number);
        if (![n,q,total,each].every(Number.isSafeInteger) || each !== unit || total !== q * unit || seen.has(n)) return false;
        seen.add(n); return true;
      });
      summary.replaceChildren();
      const total = valid ? parsed.reduce((n,m) => n + Number(m[3]), 0) : 0;
      const reviewed = valid && total === quantity * unit;
      if (reviewed) {
        for (const m of parsed) {
          const line = document.createElement('div');
          line.textContent = `Platter ${m[1]} · ${m[3]} pieces`; summary.append(line);
        }
      } else {
        const warning = document.createElement('p');
        warning.className = 'gpp-cart-review';
        warning.textContent = valid ? 'Platter arrangement requires review — quantity has changed.' : 'Platter arrangement requires review — see original details.';
        summary.append(warning);
        if (!valid) this.querySelector('details').open = true;
      }
    }
  }
  customElements.define('gpp-cart-arrangement', GPPCartArrangement);
})();
